import SupplierNotification from '../SupplierNotification.vue'

export default [
    {
        path: '/supplier_notification',
        component: SupplierNotification,
        name: 'supplier_notification',
    }
]